<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-06-20 17:27:37
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-30 10:40:11
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\newPatientmanage\components\UserEvent\index.vue
-->
<template>
  <div class="event-adverse">
    <div class="user-event" v-if="userData.patientArchivesLeftVO && userData.patientArchivesLeftVO.idCard">
      <div class="top">
        <div class="title">不良事件管理</div>
        <div>
          <el-button type="primary" style="background:#1A7BFC;border-color:#1A7BFC;margin-right:25px" size="mini"
            @click="addAdverseEvent">新增不良事件上报</el-button>
        </div>
      </div>
      <div class="table-content">
        <div class="table-text">
          <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
            <el-table id="tableInfo" :data="tableData" style="width: 98%">
              <el-table-column prop="id" label="事件记录号" align="center" fixed></el-table-column>
              <el-table-column prop="eventType" label="上报事件业务类型" align="center"></el-table-column>
              <el-table-column prop="eventCreateTime" label="事件发生时间" align="center"></el-table-column>
              <el-table-column prop="departmentName" label="上报科室" align="center"></el-table-column>
              <el-table-column prop="belongTo" label="上报机构" align="center"></el-table-column>
              <el-table-column prop="reportName" label="上报人" align="center"></el-table-column>
              <el-table-column prop="result" label="处理结果" align="center" width="200" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="viewEvent(scope.row,scope.$index)">查看</el-button>
                  <el-button type="text" size="small" @click="editEvent(scope.row,scope.$index)">编辑</el-button>
                  <el-button type="text" size="small" @click="deleteEvent(scope.row,scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination style="margin-bottom:50px;text-align:right;margin-right:30px;margin-top:20px" background
              @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="current"
              :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </el-scrollbar>
        </div>
      </div>
      <AddDialog ref="addDialog" />
    </div>
    <!-- 未实名认证 -->
    <div class="empty" v-else>
      <div class="flex-empty">
        <img src="@/assets/images/patient-noname.png" alt="no-data">
        <div class="banner-text">患者尚未实名认证</div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiAddArchivesList, apideleteEvent } from "../../api/treatmentPlan";
import AddDialog from "./components/addDialog.vue";
export default {
  components: {
    AddDialog
  },
  name: "UserEvent",
  props: {
    userData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: [],
      current: 1,
      size: 10,
      total: 1
    };
  },
  watch: {
    userData: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.archivesList();
        }
      }
    }
  },
  methods: {
    /**
     * @description:  获取列表接口
     * @param  {*}
     * @return {*}
     */
    archivesList() {
      apiAddArchivesList({
        patientId: this.userData.patientId,
        size: this.size,
        current: this.current
      }).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    //分页触发事件
    handleSizeChange(val) {
      this.size = val;
      this.archivesList();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.archivesList();
    },
    //新增不良事件上报
    addAdverseEvent() {
      this.$refs.addDialog.openDialog(this.userData.patientArchivesLeftVO);
    },
    //编辑事件
    editEvent(row, index) {
      this.$refs.addDialog.editDialog(row);
    },
    viewEvent(row, index) {
      this.$refs.addDialog.viewDialog(row);
    },
    //删除事件
    deleteEvent(row, index) {
      this.$confirm("是否要删除该不良事件", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(() => {
        apideleteEvent(row.id).then(res => {
          if (res.code == 0) {
            this.$message({
              message: "成功",
              type: "success"
            });
            this.archivesList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    }
  }
};
</script>



<style lang="less" scoped>
.event-adverse {
  height: calc(100vh - 300px);
  width: 100%;
  background: #fff;
  border-radius: 5px;
  padding: 15px;
  overflow: hidden;
  padding-bottom: 30px;
  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    .banner-text {
      margin: 20px 0 60px 0;
      text-align: center;
    }
  }
  .user-event {
    width: 100%;
    height: 100%;
    .top {
      display: flex;
      justify-content: space-between;
      .title {
        margin-bottom: 20px;
        font-size: 14px;
        color: #333;
      }
    }
    .table-content {
      height: 100%;
      background: 100%;
      .table-text {
        height: 100%;
        width: 100%;
      }
    }
  }
}

/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}
/deep/.el-table th > .cell {
  color: #333;
  font-weight: bold;
}
/deep/.el-table th {
  background: #fafafa;
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
